var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearBroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7869 0.25L12.75 1.16495L8.87046 4.84407C9.59618 5.83634 9.69791 7.02835 9.08749 7.80155L4.801 3.72938C5.61489 3.14948 6.86964 3.24613 7.91413 3.93557L11.7869 0.25ZM2.67811 9.8183C1.31484 8.5232 0.480602 6.9768 0.25 5.5335L3.55982 4.18686L8.60594 8.98067L7.18842 12.125C5.66915 11.9059 4.04137 11.1134 2.67811 9.8183Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearBroom);
export default __webpack_public_path__ + "static/media/clear-broom.583e7cb8.svg";
export { ForwardRef as ReactComponent };